import React, { useEffect, useState } from "react"

import { EditButton } from "../../../components/atoms/buttons"
import { AddressTypes, ChangeAddressCommand } from "../address/editAddress/types"
import { EditAddressForm } from "../address/editAddress/editAddressForm"
import { GetCommandResponse, useCommandBackend } from "../../../utils/requestHelpers"
import { CommandWithSchema } from "../../../common-types/commandingTypes"

type EditInvoiceAddressProps = {
  nodeId: string;
  onClose: () => void;
  onSave: (invoiceAddress: any) => void;
}

export const EditInvoiceAddress = ({ nodeId, onClose, onSave }: EditInvoiceAddressProps) => {
    const commandApi = useCommandBackend("Backoffice")
    const addressType = "Invoice"
    const [changeAddress, setChangeAddress] = useState<CommandWithSchema<ChangeAddressCommand> | undefined>()

    useEffect(() => {
      const updateChangeInvoiceAddressCommand = (nodeId: string, type: AddressTypes) => 
        commandApi.Get<GetCommandResponse<ChangeAddressCommand>>(`/cmd/node/address/change/node/${nodeId}/type/${type}`)
          .Data(a => setChangeAddress(a))
          .Empty(() => setChangeAddress(undefined))
          .Rejected(() => setChangeAddress(undefined))
      
      updateChangeInvoiceAddressCommand(nodeId, addressType)
    
    }, [nodeId, commandApi])

    const save = (command: ChangeAddressCommand) => {
        commandApi.PostCommand('/cmd/node/address/change', command)
            .Data(result => {
              console.log("Successfully saved the invoice address:", result.message)
              onClose()
            })
            .Catch(e => {
              console.warn("An error occured when saving invoice address:", e.message)
            })
    }

    return(
        <div>
            {changeAddress ? (
                <EditAddressForm 
                  addressType={addressType} 
                  command={changeAddress}
                  onClose={onClose} 
                  onSave={(command) => {save(command); onSave(command ? ({ 
                    streetAddress: command.streetAddress,
                    extraAddress: command?.extraAddress, 
                    postalCode: command.postalCode, 
                    locality: command.locality, 
                    country: command.country }) 
                    : undefined)}}
                />
            ) : (
                <div>Loading...</div>
            )}
        </div>
    )
}